import * as _ from 'lodash';
import {Helpers} from "./helpers/helpers";
import {SiteHelpers} from "./helpers/site-helpers";


export const MAP_STYLES = [
	{
		"elementType": "geometry",
		"stylers": [
			{
				"color": "#f5f5f5"
			}
		]
	},
	{
		"elementType": "labels.icon",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"elementType": "labels.text.fill",
		"stylers": [
			{
				"color": "#616161"
			}
		]
	},
	{
		"elementType": "labels.text.stroke",
		"stylers": [
			{
				"color": "#f5f5f5"
			}
		]
	},
	{
		"featureType": "administrative.land_parcel",
		"elementType": "labels.text.fill",
		"stylers": [
			{
				"color": "#bdbdbd"
			}
		]
	},
	{
		"featureType": "poi",
		"elementType": "geometry",
		"stylers": [
			{
				"color": "#eeeeee"
			}
		]
	},
	{
		"featureType": "poi",
		"elementType": "labels.text.fill",
		"stylers": [
			{
				"color": "#757575"
			}
		]
	},
	{
		"featureType": "poi.park",
		"elementType": "geometry",
		"stylers": [
			{
				"color": "#e5e5e5"
			}
		]
	},
	{
		"featureType": "poi.park",
		"elementType": "labels.text.fill",
		"stylers": [
			{
				"color": "#9e9e9e"
			}
		]
	},
	{
		"featureType": "road",
		"elementType": "geometry",
		"stylers": [
			{
				"color": "#ffffff"
			}
		]
	},
	{
		"featureType": "road.arterial",
		"elementType": "labels.text.fill",
		"stylers": [
			{
				"color": "#757575"
			}
		]
	},
	{
		"featureType": "road.highway",
		"elementType": "geometry",
		"stylers": [
			{
				"color": "#dadada"
			}
		]
	},
	{
		"featureType": "road.highway",
		"elementType": "labels.text.fill",
		"stylers": [
			{
				"color": "#616161"
			}
		]
	},
	{
		"featureType": "road.local",
		"elementType": "labels.text.fill",
		"stylers": [
			{
				"color": "#9e9e9e"
			}
		]
	},
	{
		"featureType": "transit.line",
		"elementType": "geometry",
		"stylers": [
			{
				"color": "#e5e5e5"
			}
		]
	},
	{
		"featureType": "transit.station",
		"elementType": "geometry",
		"stylers": [
			{
				"color": "#eeeeee"
			}
		]
	},
	{
		"featureType": "water",
		"elementType": "geometry",
		"stylers": [
			{
				"color": "#c9c9c9"
			}
		]
	},
	{
		"featureType": "water",
		"elementType": "labels.text.fill",
		"stylers": [
			{
				"color": "#9e9e9e"
			}
		]
	}
];


export class Locator {
	private searchUrl = "/distributor/search/";
	private salesManagerUrl = "/distributor/sales-rep/";
	private wrapper: HTMLElement;
	private searchInput: HTMLInputElement;
	private currentLocationButton: HTMLButtonElement;
	private mapViewOptionElement: HTMLElement;
	private listViewOptionElement: HTMLElement;
	private searchAreaButton: HTMLButtonElement;
	private messageElement: HTMLElement;
	private noResultsElement: HTMLElement;
	private sidebarElement: HTMLElement;
	private resultsElement: HTMLElement;
	private mapElement: HTMLElement;
	private resultTemplate: HTMLElement;
	private infoWindowTemplate: HTMLElement;
	private maxResults: number;
	private searchRadius: number;
	private useTeamData: boolean;
	private mapWrapperElement: HTMLElement;
	private centerLatLng: string;
	private map: google.maps.Map;
	private markers: google.maps.Marker[];
	private infoWindow: google.maps.InfoWindow;
	private autocomplete: google.maps.places.Autocomplete;
	private placesService: google.maps.places.PlacesService;
	private lastSearchCoords: google.maps.LatLng;
	private skipNextIdleEvent: boolean;
	private delayedInputSearch: NodeJS.Timeout;
	private mapIdleDebounce: (() => void);
	private productFilterDropdown: HTMLSelectElement;
	private stateFilterDropdown: HTMLSelectElement;
	private countryFilterDropDown: HTMLSelectElement;
	private submitSearchButton: HTMLButtonElement;
	private countyFilterDropDown: HTMLSelectElement;
	private saleManagerElement: HTMLElement;
	private mapLoaderElement: Element;
	private mapSidebarContainerElement: Element;

	public constructor(element: HTMLElement) {
		this.wrapper = element;
		this.searchInput = element.querySelector(".search-input") as HTMLInputElement;
		this.currentLocationButton = element.querySelector(".current-location");
		this.productFilterDropdown = element.querySelector(".product-filter") as HTMLSelectElement;
		this.stateFilterDropdown = element.querySelector(".state-filter") as HTMLSelectElement;
		this.countryFilterDropDown = element.querySelector(".country-filter") as HTMLSelectElement;
		this.countyFilterDropDown = element.querySelector(".county-filter") as HTMLSelectElement;
		this.submitSearchButton = element.querySelector(".search-fields button") as HTMLButtonElement;
		this.searchAreaButton = element.querySelector(".search-area");
		this.mapViewOptionElement = element.querySelector(".view-options .map-option");
		this.listViewOptionElement = element.querySelector(".view-options .list-option");
		this.messageElement = element.querySelector(".results-message");
		this.noResultsElement = element.querySelector(".no-results");
		this.sidebarElement = element.querySelector(".sidebar-results");
		this.mapSidebarContainerElement = element.querySelector('.map-sidebar-container');
		this.mapLoaderElement = element.querySelector('.map-sidebar-container .loader');
		this.resultsElement = element.querySelector(".results-list");
		this.mapWrapperElement = element.querySelector(".map-wrapper");
		this.mapElement = element.querySelector(".map");
		this.resultTemplate = element.querySelector(".dealer-result.template");
		this.infoWindowTemplate = element.querySelector(".dealer-info-window.template");
		this.saleManagerElement = element.querySelector('.sales-manager')
		this.maxResults = parseInt(element.dataset.maxResults);
		this.searchRadius = parseInt(element.dataset.searchRadius);
		this.useTeamData = element.dataset.useTeams === "True";

		this.centerLatLng = this.mapWrapperElement.dataset.mapcenter;
		this.initMap();
		this.initStateCountyDropDown();
		if (!this.useTeamData) {
			this.initCurrentLocationButton();
			this.initSearchButton();
			this.initAutocomplete();
		} else {

			this.searchUrl = "/team-members/search";
		}
		this.initSearchAreaButton();
		this.initViewOptions();
		this.skipNextIdleEvent = true;
		this.searchFromQueryString();

		if (this.saleManagerElement) {
			this.setupSalesManagerMobile();
		}
	}

	private setupSalesManagerMobile() {
		const toggles = this.saleManagerElement.querySelectorAll('.title');
		const title = this.saleManagerElement.querySelector('.title');
		const managerDetails = this.saleManagerElement.querySelector('.manager-details');		
		toggles.forEach(t =>
			t.addEventListener('click', (e) => {
				e.preventDefault();				
				title.classList.toggle("open");
				managerDetails.classList.toggle("open");
			}));
	}

	private clearStateCountyDropDowns() {
		if (this.countryFilterDropDown) {
			this.countryFilterDropDown.value = '';
		}
		if (this.stateFilterDropdown) {
			this.stateFilterDropdown.value = '';
		}
		if (this.countyFilterDropDown) {
			this.countyFilterDropDown.value = '';
		}
	}

	private initStateCountyDropDown() {
		const searchInput = this.searchInput;
		const clearSearchInput = function () {
			if (searchInput) {
				searchInput.value = "";
			}
		}

		this.countryFilterDropDown?.addEventListener('change', () => {
			const country = this.countryFilterDropDown.value;
			clearSearchInput();
			if (country !== "USA" && country !== "Canada") {
				this.stateFilterDropdown.value = "";
				this.countyFilterDropDown.value = "";

				this.search(0.0, 0.0);
			}
		});
		this.stateFilterDropdown?.addEventListener('change', () => {
			clearSearchInput();
			if (this.countryFilterDropDown.value === "Canada") {
				this.countyFilterDropDown.value = "";
				
				var numOfOptions = this.countyFilterDropDown.querySelectorAll('option').length;
				if (numOfOptions <=1) {
					this.search(0.0, 0.0);
				}
			}
		});
		this.countyFilterDropDown?.addEventListener('change', () => {
			clearSearchInput();
			this.search(0.0, 0.0);
		});
	}

	private initSearchAreaButton() {
		this.searchAreaButton.addEventListener("click", () => {
			const center = this.map.getCenter();
			this.search(center.lat(), center.lng());
			this.hideSearchAreaButton();
		});
	}

	private initSearchButton() {
		this.submitSearchButton.addEventListener("click", () => {
			this.searchByQuery(this.searchInput.value);
		});
	}

	private initAutocomplete(): void {
		 
		const culture = Helpers.getCurrentCulture();
		if (SiteHelpers.isEasternHemisphere() || SiteHelpers.isEhCulture() ) {
			
			const options = {
				types: ['geocode']
			};

			if (SiteHelpers.isEhCulture()) {
				
				this.autocomplete = new google.maps.places.Autocomplete(this.searchInput,  {
					types: ['geocode'],
					componentRestrictions: { country: ["au", "nz", "pg", "fj","nc","vu","sb","ck"]}
				});
			} else {
				this.autocomplete = new google.maps.places.Autocomplete(this.searchInput, options);
			}
			
			
			this.autocomplete.addListener("place_changed", () => { this.onPlaceChanged.apply(this); });
			this.placesService = new google.maps.places.PlacesService(this.map);
		}
		this.searchInput.addEventListener("keypress", (event) => { this.onSearchInputKeypress.apply(this, [event]); });
	}

	private onPlaceChanged() {
		this.cancelDelayedInputSearch();

		const place = this.autocomplete.getPlace();
		if (!place.geometry) {
			return;
		}
		const latitude = place.geometry.location.lat();
		const longitude = place.geometry.location.lng();

		this.search(latitude, longitude);

	};

	private onSearchInputKeypress(event: KeyboardEvent) {
		if (event.keyCode !== 13) {
			return;
		}

		const self = this;
		self.searchByQuery(self.searchInput.value);
		self.cancelDelayedInputSearch();
		if (SiteHelpers.isEasternHemisphere() || SiteHelpers.isEhCulture()) {

			this.delayedInputSearch = (setTimeout(() => {
				const selectedPlace = self.autocomplete.getPlace();
				if (Helpers.isNullOrUndefined(selectedPlace.place_id)) {
					self.searchByQuery(self.searchInput.value);
				}
			}, 500) as any)
		}
	}

	private searchByQuery(query: string) {


		this.clearResults();
		this.clearStateCountyDropDowns();
		if (!SiteHelpers.isEasternHemisphere() && !SiteHelpers.isEhCulture()) {
			this.search(0.0, 0.0);
			return;
		}

		const request = {
			fields: ["formatted_address", "geometry.location"],
			query: query
		};
		this.placesService?.findPlaceFromQuery(request, (results) => {

			if (results?.length > 0) {
				const place = results[0];
				const latitude = place.geometry.location.lat();
				const longitude = place.geometry.location.lng();
				this.search(latitude, longitude);
			} else {
				this.clearResults();
				this.search(0.0, 0.0);
			}
		});
	}

	private cancelDelayedInputSearch(): void {
		if (this.delayedInputSearch) {
			clearTimeout(this.delayedInputSearch);
			this.delayedInputSearch = null;
		}
	}

	private searchFromQueryString(): boolean {
		const urlParameters = Helpers.getUrlParameters();
		let preformQuerySearch = false;
		var event = new Event('change');
		if (urlParameters.countryCode && urlParameters.countryCode !== "" && this.countryFilterDropDown) {
			this.countryFilterDropDown.value = urlParameters.countryCode;
			this.countryFilterDropDown.dispatchEvent(event);
			preformQuerySearch = true;
		}
		if (urlParameters.stateCode && urlParameters.stateCode !== "" && this.stateFilterDropdown) {
			this.stateFilterDropdown.value = urlParameters.stateCode;
			this.stateFilterDropdown.classList.remove('d-none');

			this.stateFilterDropdown.dispatchEvent(event);
			preformQuerySearch = true;
		}

		if (urlParameters.countyId && urlParameters.countyId !== "" && this.countyFilterDropDown) {
			console.log("set county" + urlParameters.countyId);
			this.countyFilterDropDown.value = urlParameters.countyId;
			this.countyFilterDropDown.classList.remove('d-none');
			preformQuerySearch = true;

		}


		if (urlParameters.query && urlParameters.query !== "") {
			this.searchInput.value = urlParameters.query;
			this.searchByQuery(urlParameters.query);
			return true;
		}

		const latitude = parseFloat(urlParameters.lat);
		const longitude = parseFloat(urlParameters.lon);

		if (latitude && longitude) {
			this.search(latitude, longitude);
			return true;
		}

		if (preformQuerySearch) {
			this.search(0, 0);
		}

		return false;
	}

	private initViewOptions(): void {
		this.mapViewOptionElement.addEventListener("click", () => {
			this.mapViewOptionElement.classList.add("selected");
			this.mapWrapperElement.classList.add("selected");

			this.listViewOptionElement.classList.remove("selected");
			this.sidebarElement.classList.remove("selected");
		});

		this.listViewOptionElement.addEventListener("click", () => {
			this.listViewOptionElement.classList.add("selected");
			this.sidebarElement.classList.add("selected");

			this.mapViewOptionElement.classList.remove("selected");
			this.mapWrapperElement.classList.remove("selected");
		});
	}

	private initMap(): void {
		let mapCenter = new google.maps.LatLng(37.09024, -95.712891);
		if (this.centerLatLng) {
			const latLng = this.centerLatLng.split(',');
			if (latLng.length > 1) {
				mapCenter = new google.maps.LatLng(parseFloat(latLng[0].trim()), parseFloat(latLng[1].trim()));
			}
		}

		const options: google.maps.MapOptions = {
			zoom: 5,
			center: mapCenter, // US center point
			scrollwheel: false,
			streetViewControl: false,
			mapTypeControl: false,
			styles: MAP_STYLES
		};

		this.map = new google.maps.Map(this.mapElement, options);

		this.markers = [];
		this.infoWindow = new google.maps.InfoWindow();
		this.lastSearchCoords = new google.maps.LatLng(0, 0);

		this.mapIdleDebounce = _.debounce(() => {
			if (this.skipNextIdleEvent) {
				this.skipNextIdleEvent = false;
				return;
			}

			const distanceFromLastSearchMeters = google.maps.geometry.spherical.computeDistanceBetween(this.map.getCenter(), this.lastSearchCoords);
			const mapBounds = this.map.getBounds();
			const mapDiagonalDistance = google.maps.geometry.spherical.computeDistanceBetween(mapBounds.getNorthEast(), mapBounds.getSouthWest());
			const mapZoomLevel = this.map.getZoom();
			if (mapZoomLevel < 8) {
				this.hideSearchAreaButton();
			} else if (distanceFromLastSearchMeters > mapDiagonalDistance * 0.25) {
				this.showSearchAreaButton();
			}


		}, 500);

		this.map.addListener("idle", () => {
			this.mapIdleDebounce();
		});
	}

	private showSearchAreaButton(): void {
		this.searchAreaButton.classList.remove("hidden");
	}

	private initCurrentLocationButton() {
		this.currentLocationButton.addEventListener("click", () => {
			this.searchUsingCurrentLocation();
		});
	}
	
	private toggleMapLoader(showLoader = false) {
		if (showLoader) {
			this.mapSidebarContainerElement.classList.add('loading');
			this.mapLoaderElement.classList.remove('d-none')
		} else {
			this.mapSidebarContainerElement.classList.remove('loading');
			this.mapLoaderElement.classList.add('d-none')
		}
	}

	private search(latitude: number, longitude: number): void {
		const self = this;
		this.toggleMapLoader(true);
		const distributorSearchRequest = new XMLHttpRequest();

		distributorSearchRequest.open("POST", this.searchUrl, true);

		distributorSearchRequest.setRequestHeader("Content-Type", "application/json");


		distributorSearchRequest.onload = function () {
			if (this.status >= 200 && this.status < 400) {
				const results = JSON.parse(this.response) as Distributor[];
				self.lastSearchCoords = new google.maps.LatLng(latitude, longitude);
				self.updateUrlSearchParameters(latitude, longitude);
				self.clearResults();
				self.loadResults(results);
				const rsm = results.find(r => r.isSalesManager);
				if (rsm) {
					self.loadSalesManager(rsm);
				}
			} else {
				self.messageElement.innerText = self.getFormattedErrorMessage();
			}
			self.toggleMapLoader(false);
		}


		distributorSearchRequest.onerror = () => {
			self.messageElement.innerText = self.getFormattedErrorMessage();
			this.toggleMapLoader(false);
		}

		const searchRequest = {
			latitude: latitude,
			longitude: longitude,
			maxResults: this.maxResults,
			searchRadius: this.searchRadius,
			productAndSystems: this.productFilterDropdown?.value,
			query: this.searchInput?.value,
			culture: Helpers.getCurrentCulture(),
			stateCode: this.stateFilterDropdown?.value,
			countyId: this.countyFilterDropDown?.value,			
			countryCode: this.countryFilterDropDown?.value,
		} as SearchRequest;

		distributorSearchRequest.send(JSON.stringify(searchRequest));
	}

	private searchUsingCurrentLocation(): void {
		if (!("geolocation" in navigator)) {
			return;
		}
		this.toggleMapLoader(true);

		navigator.geolocation.getCurrentPosition(
			(position) => {
				this.searchInput.value = "";
				this.search(position.coords.latitude, position.coords.longitude);
			},
			(error) => {
				console.warn(error);
				let message = "";
				switch (error.code) {
					case error.PERMISSION_DENIED:
						message = "Access to your location was denied.";
						break;
					case error.POSITION_UNAVAILABLE:
					case error.TIMEOUT:
						message = "Your location could not be determined.";
						break;
				}
				if (message.length > 0) {
					alert(message);
				}
			}
		);
	}

	private clearResults(): void {
		this.resultsElement.innerHTML = "";
		this.messageElement.innerHTML = "";

		for (const marker of this.markers) {
			marker.setMap(null);
			google.maps.event.clearInstanceListeners(marker);
		}
		this.markers = [];
	}

	private loadSalesManager(result: Distributor) {
		const managerElem = document.querySelector('.sales-manager') as HTMLElement;
		const image = managerElem.querySelector('.image') as HTMLElement;
		const name = managerElem.querySelector('.name') as HTMLElement;
		const subtitle = managerElem.querySelector('.subtitle') as HTMLElement;
		const phone = managerElem.querySelector('.phone a') as HTMLAnchorElement;
		const email = managerElem.querySelector('.email a') as HTMLAnchorElement;
		const button = managerElem.querySelector('.button-secondary') as HTMLAnchorElement;


		image.classList.add('d-none'); //no image defined.
		let rsmName = result.salesManagerName;
		let rsmTitle = result.salesManagerTitle
		if (!rsmName) {
			const nameSplit = result.name.split('-');
			rsmName = nameSplit[0].trim();
			if (nameSplit.length > 1) {
				rsmTitle = nameSplit[1].trim();
			}
		}

		name.innerText = rsmName;
		subtitle.innerText = rsmTitle;

		phone.innerText = result.phone;
		phone.href = `tel:${result.phone}`;

		email.innerText = result.contactEmail;
		email.href = `tel:${result.contactEmail}`;

		button.href = result.detailPage.replace('~', '');

		managerElem.classList.remove('d-none');

	}

	private loadResults(results: Distributor[]): void {
		const largestDistances = results.map((r) => {
			return r.distance;
		}).sort();

		const radius = Math.ceil(largestDistances[0] / 100) * 100;
		this.messageElement.innerText = this.getFormattedResultsMessage(results.length, radius);

		if (results.length === 0) {
			this.map.setCenter(this.lastSearchCoords);
			this.map.setZoom(9);
			this.showNoResultsMessage();
			return;
		}

		this.hideNoResultsMessage();

		const bounds = new google.maps.LatLngBounds();

		for (let index = 0; index < results.length; index++) {
			const dealer = results[index];
			const resultElement = this.createDealerResultElement(dealer);
			const listElement = document.createElement("li");
			if (dealer.isSalesManager) {
				listElement.classList.add('is-rsm');
			}
			listElement.appendChild(resultElement);
			this.resultsElement.appendChild(listElement);

			const markerPosition = new google.maps.LatLng(dealer.latitude, dealer.longitude);
			bounds.extend(markerPosition);

			const isGeopier = window.location.href.indexOf('geopier.com') > -1
			const primaryColor = isGeopier ? '#a7ce3c' : '#525d6d';

			let markerOptions: google.maps.MarkerOptions = {
				map: this.map,
				draggable: false,
				position: markerPosition,
				icon: {
					path: google.maps.SymbolPath.CIRCLE,
					scale: 10,
					fillOpacity: 1,
					fillColor: primaryColor,
					strokeColor: primaryColor
				},
				label: {
					text: `${index + 1}`,
					color: "#A6CE39",
					fontSize: "14px",
					fontWeight: "bold"
				}
			};
			
			if (!isGeopier && dealer.isSalesManager) {
				const rsmSvg = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
										<g id="Frame 54">
											<circle id="Oval Copy 29" cx="16" cy="16" r="16" fill="#009CA2"/>
											<path id="Vector" d="M16 16C17.3738 16 18.5632 15.5073 19.5353 14.5351C20.5071 13.5631 21 12.3738 21 10.9998C21 9.62634 20.5073 8.43688 19.5352 7.46457C18.563 6.49273 17.3736 6 16 6C14.6261 6 13.4368 6.49273 12.4648 7.46473C11.4929 8.43673 11 9.62618 11 10.9998C11 12.3738 11.4929 13.5633 12.4648 14.5353C13.4371 15.5071 14.6265 16 16 16ZM13.3252 8.32491C14.071 7.57908 14.9458 7.21654 16 7.21654C17.054 7.21654 17.929 7.57908 18.675 8.32491C19.4208 9.07089 19.7835 9.94596 19.7835 10.9998C19.7835 12.054 19.4208 12.9289 18.675 13.6749C17.929 14.4209 17.054 14.7835 16 14.7835C14.9462 14.7835 14.0713 14.4208 13.3252 13.6749C12.5792 12.9291 12.2165 12.054 12.2165 10.9998C12.2165 9.94596 12.5792 9.07089 13.3252 8.32491Z" fill="white"/>
											<path id="Vector_2" d="M23.9612 21.5306C23.9353 21.1537 23.8829 20.7425 23.8058 20.3084C23.728 19.8709 23.6278 19.4574 23.5078 19.0794C23.3837 18.6888 23.2153 18.303 23.0068 17.9333C22.7907 17.5496 22.5367 17.2155 22.2517 16.9405C21.9537 16.6529 21.5887 16.4216 21.1668 16.253C20.7463 16.0852 20.2803 16.0001 19.7818 16.0001C19.586 16.0001 19.3967 16.0812 19.031 16.3213C18.806 16.4693 18.5428 16.6405 18.249 16.8299C17.9978 16.9913 17.6574 17.1426 17.2371 17.2795C16.827 17.4134 16.4106 17.4813 15.9994 17.4813C15.5886 17.4813 15.1722 17.4134 14.7617 17.2795C14.3418 17.1427 14.0014 16.9915 13.7506 16.83C13.4596 16.6424 13.1962 16.4712 12.9678 16.3211C12.6024 16.081 12.4131 16 12.2173 16C11.7187 16 11.2528 16.0852 10.8325 16.2531C10.4108 16.4215 10.0458 16.6528 9.74743 16.9407C9.46241 17.2158 9.20841 17.5498 8.99245 17.9333C8.78424 18.303 8.61569 18.6886 8.49161 19.0796C8.37178 19.4575 8.27156 19.8709 8.19372 20.3084C8.11647 20.742 8.06423 21.1533 8.03833 21.5311C8.01288 21.9005 8 22.2849 8 22.6734C8 23.6831 8.31823 24.5006 8.94577 25.1034C9.56556 25.6983 10.3855 26 11.3829 26H20.6171C21.6142 26 22.4341 25.6983 23.0541 25.1034C23.6818 24.501 24 23.6833 24 22.6732C23.9999 22.2834 23.9868 21.899 23.9612 21.5306ZM22.2792 24.2821C21.8697 24.6753 21.326 24.8664 20.6169 24.8664H11.3829C10.6737 24.8664 10.13 24.6753 9.72065 24.2823C9.31902 23.8967 9.12384 23.3702 9.12384 22.6734C9.12384 22.3109 9.13569 21.953 9.15939 21.6094C9.18251 21.2724 9.22977 20.9021 9.29985 20.5086C9.36906 20.12 9.45714 19.7554 9.5619 19.4252C9.66242 19.1087 9.79951 18.7952 9.96953 18.4932C10.1318 18.2055 10.3185 17.9586 10.5245 17.7596C10.7172 17.5735 10.9601 17.4212 11.2463 17.307C11.5109 17.2013 11.8084 17.1435 12.1313 17.1348C12.1707 17.1559 12.2408 17.1962 12.3543 17.2708C12.5853 17.4227 12.8516 17.596 13.146 17.7856C13.4778 17.999 13.9054 18.1917 14.4162 18.3581C14.9383 18.5284 15.4709 18.6149 15.9996 18.6149C16.5282 18.6149 17.0609 18.5284 17.5828 18.3582C18.094 18.1916 18.5214 17.999 18.8537 17.7853C19.155 17.5911 19.4138 17.4228 19.6448 17.2708C19.7584 17.1963 19.8284 17.1559 19.8678 17.1348C20.1909 17.1435 20.4883 17.2013 20.7531 17.307C21.0392 17.4212 21.2821 17.5737 21.4748 17.7596C21.6808 17.9584 21.8675 18.2053 22.0297 18.4934C22.1999 18.7952 22.3371 19.1088 22.4375 19.4251C22.5424 19.7557 22.6306 20.1202 22.6997 20.5085C22.7696 20.9027 22.8171 21.2731 22.8402 21.6096V21.6099C22.864 21.9521 22.876 22.3099 22.8762 22.6734C22.876 23.3704 22.6808 23.8967 22.2792 24.2821Z" fill="white"/>
										</g>
										</svg>
`;
				markerOptions = {
					map: this.map,
					draggable: false,
					position: markerPosition,
					icon: {
						anchor: new google.maps.Point(0,0),
						scaledSize: new google.maps.Size(32, 32),
						url: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(rsmSvg)
					},
					label: null
				};				
			}
			
			
		

			const marker = new google.maps.Marker(markerOptions);

			const selectDealer = () => {
				this.infoWindow.setContent(this.createInfoWindowContent(dealer, index + 1));
				this.infoWindow.open(this.map, marker);
				if (!this.map.getBounds().contains(markerPosition)) {
					this.map.setCenter(markerPosition);
				}
			};

			marker.addListener("click", selectDealer);
			this.markers.push(marker);


		}

		this.skipNextIdleEvent = true;

		this.map.fitBounds(bounds);

		const currentZoom = this.map.getZoom();
		if (currentZoom > 10) {
			this.map.setZoom(10);
		}
	}

	private createDealerResultElement(dealer: Distributor): HTMLElement {
		const resultElement = this.resultTemplate.cloneNode(true) as HTMLElement;
		const distanceLabel = resultElement.querySelector(".distance");
		resultElement.classList.remove("template");
		resultElement.querySelector(".name").innerHTML = dealer.name;
		const dealersWithNationwideDelivery = [
			'tcs geotechnics',
			'tensar international ltd.'
		];

		if (dealersWithNationwideDelivery.includes(dealer.name.toLowerCase())) {
			distanceLabel.innerHTML = 'Delivers Nationwide';
		} else if (dealer.distance > 0 && dealer.distance < 500) {
			distanceLabel.innerHTML = this.getFormattedDistanceMessage(dealer.distance);
		} else {
			distanceLabel.classList.add('d-none');
		}

		resultElement.querySelector(".learn-more").setAttribute("href", dealer.detailPage.replace('~', ''));
		return resultElement;
	}

	private updateUrlSearchParameters(latitude: number, longitude: number): void {
		const urlParameters = {
			lat: latitude.toFixed(6),
			lon: longitude.toFixed(6),
			query: '',
			stateCode: this.stateFilterDropdown?.value,
			countryCode: this.countryFilterDropDown?.value,
			countyId: this.countyFilterDropDown?.value
		};


		if (this.searchInput?.value) {
			urlParameters.query = this.searchInput.value;
		}

		Helpers.updateUrl(urlParameters);
	}

	private showNoResultsMessage(): void {
		this.noResultsElement.classList.remove("hidden");
	}

	private hideNoResultsMessage(): void {
		this.noResultsElement.classList.add("hidden");
	}

	private hideSearchAreaButton(): void {
		this.searchAreaButton.classList.add("hidden");
	}

	private createInfoWindowContent(dealer: Distributor, itemNumber: number): HTMLElement {
		const infoWindowElement = this.infoWindowTemplate.cloneNode(true) as HTMLElement;
		infoWindowElement.classList.remove("template");

		const nameElement = infoWindowElement.querySelector(".name") as HTMLElement;
		nameElement.innerHTML = dealer.name;
		nameElement.dataset.itemNumber = itemNumber.toString();
		const descriptionElement = infoWindowElement.querySelector(".description");
		if (!this.useTeamData) {
			infoWindowElement.querySelector(".address").innerHTML = this.getFormattedAddress(dealer);
			infoWindowElement.querySelector(".distance").innerHTML = this.getFormattedDistanceMessage(dealer.distance);
		}

		if (dealer.description?.length > 0) {
			descriptionElement.innerHTML = dealer.description;
		} else {
			descriptionElement.classList.add("d-none");
		}

		const learnMore = infoWindowElement.querySelector(".learn-more") as HTMLAnchorElement;
		learnMore.href = dealer.detailPage.replace('~', '');

		infoWindowElement.querySelector(".phone").innerHTML = dealer.phone;

		return infoWindowElement;
	}

	private getFormattedResultsMessage(resultCount: number, searchRadius = 0): string {
		if (searchRadius === 0) {
			searchRadius = this.searchRadius;
		}

		if (isNaN(searchRadius)) {
			return "";
		}
		const formatField = this.wrapper.querySelector('.results-found-format') as HTMLInputElement;
		var format = formatField.value;
		return format.replace('{0}', resultCount.toString()).replace('{1}', searchRadius.toString());
	}

	private getFormattedErrorMessage(): string {
		return "Unable to load results.  Please try again.";
	}


	private getFormattedAddress(dealer: Distributor): string {
		let address = "";

		if (dealer.street1?.length > 0) {
			address += `${dealer.street1}<br />`;
		}
		if (dealer.street2?.length > 0) {
			address += `${dealer.street2}<br />`;
		}

		const regionParts: string[] = [];

		if (dealer.city?.length > 0) {
			regionParts.push(dealer.city);
		}
		if (dealer.stateProvince?.length > 0) {
			regionParts.push(dealer.stateProvince);
		}
		if (dealer.country?.length > 0 && dealer.country !== "USA" && dealer.country !== "United States" && dealer.country !== "CA") {
			regionParts.push(dealer.country);
		}

		address += regionParts.join(", ");

		if (dealer.postalCode.length > 0) {
			address += ` ${dealer.postalCode}`;
		}

		return address;
	}

	private getFormattedDistanceMessage(distance: number): string {

		const formatField = this.wrapper.querySelector('.miles-away-format') as HTMLInputElement;
		var format = formatField.value;

		return format.replace('{0}', distance.toString());
	}


}

declare global {
	interface Window {
		caProvinces: any[];
		usStates: any[];
		usCounties: any[];
		ukCounties: any[];
		mobileSidebarToggleRegistered: boolean;
		LiveChatWidget: any;
	}
}

interface Geocoordinate {
	latitude: number;
	longitude: number;
}

export interface Distributor {
	name: string;
	description: string;
	contactEmail: string;
	availableProducts: string[];
	street1: string;
	street2: string;
	city: string;
	stateProvince: string;
	postalCode: string;
	country: string;
	phone: string;
	latitude: number;
	longitude: number;
	distance: number;
	detailPage: string;
	website: string;
	isSalesManager: boolean;
	salesManagerTitle: string;
	salesManagerName: string;

}

export interface SearchRequest {
	latitude: number;
	longitude: number;
	maxResults: number;
	searchRadius: number;
	productAndSystems: string;
	query: string;
	stateCode: string;
	countryCode: string;
	countyId: string;
	culture: string;
}

